import classnames from 'classnames';
import { Icon } from 'common/components/icons/Icon';
import type { FC, ReactNode } from 'react';
import type { AllIconNames } from './icons/icons';
import { LoadingPanel } from './LoadingPanel';
import { SmartLink } from './SmartLink';

interface Props {
  /** Potentially used from CMS content */
  title?: string;
  /** Potentially used from CMS content */
  label?: string;
  icon?: AllIconNames;
  to?: string;
  action?: React.MouseEventHandler<HTMLElement>;
  children?: ReactNode;
  className?: string;
  inline?: boolean;
  active?: boolean;
  loading?: boolean;
  testId?: string;
}
export const ActionButton: FC<Props> = ({
  title,
  label,
  icon,
  to,
  action,
  children,
  className,
  inline = true,
  active = true,
  loading = false,
  testId,
}) => {
  // A loading button is disabled too, but keeps its colour: it is busy, not unavailable
  const mainClass = classnames('button', { inactive: !active, loading }, className);
  const onClick = active ? action : undefined;
  const content = (
    <>
      {loading && <LoadingPanel small={true} />}
      {icon && <Icon name={icon} inline={inline} className="action-icon" />}
      {title}
      {children}
      {label && <span className="label">{label}</span>}
    </>
  );
  if (to && active) {
    return (
      <SmartLink to={to} className={mainClass} onClick={onClick} aria-busy={loading || undefined} data-testid={testId}>
        {content}
      </SmartLink>
    );
  }
  return (
    <button
      type="button"
      className={mainClass}
      onClick={onClick}
      disabled={!active}
      aria-busy={loading || undefined}
      data-testid={testId}
    >
      {content}
    </button>
  );
};
